if (!customElements.get('shoppable-video-reels')) {
  class ShoppableVideoReels extends HTMLElement {
    constructor() {
      super();
      const slideshow = this,
        dataset = slideshow.dataset;

      let slideshow_slides = Array.from(slideshow.querySelectorAll('.carousel__slide')),
        autoplay = dataset.autoplay == 'false' ? false : parseInt(dataset.autoplay, 10),
        align = dataset.align == 'center' ? 'center' : 'left',
        fade = dataset.fade === 'true',
        prev_button = slideshow.querySelector('.flickity-prev'),
        next_button = slideshow.querySelector('.flickity-next');

      if (slideshow_slides.length < 1) return;

      const args = {
        wrapAround: true,
        cellAlign: align,
        pageDots: false,
        contain: true,
        fade: fade,
        autoPlay: autoplay,
        prevNextButtons: false,
        cellSelector: '.carousel__slide'
      };

      const flkty = new Flickity(slideshow, args);
      slideshow.dataset.initiated = true;

      // Pause all videos except current
      const allVideos = slideshow.querySelectorAll('video');
      flkty.cells.forEach((cell, i) => {
        const video = cell.element.querySelector('video');
        if (!video) return;
        if (i === flkty.selectedIndex) video.play();
        else video.pause();
      });

      flkty.on('change', (index) => {
        flkty.cells.forEach((cell, i) => {
          const video = cell.element.querySelector('video');
          if (!video) return;
          if (i === index) video.play();
          else video.pause();
        });
      });

      // Pause other videos if manually played
      allVideos.forEach((video) => {
        video.addEventListener('play', () => {
          allVideos.forEach((otherVideo) => {
            if (otherVideo !== video) otherVideo.pause();
          });
        });
      });

      // Prev/next buttons
      if (prev_button) {
        prev_button.addEventListener('click', () => flkty.previous());
        prev_button.addEventListener('keyup', () => flkty.previous());
      }
      if (next_button) {
        next_button.addEventListener('click', () => flkty.next());
        next_button.addEventListener('keyup', () => flkty.next());
      }
    }
  }

  customElements.define('shoppable-video-reels', ShoppableVideoReels);
}